  import { defineComponent, type PropType } from "vue";
  import ContratTemplateActive from '@/extend/controls/contratTemplate/ContratTemplateActive';
  import ContratTemplateName from '@/extend/controls/contratTemplate/ContratTemplateName';
  import ContratTemplateTitre from '@/extend/controls/contratTemplate/ContratTemplateTitre';
  import ContratTemplateUseConvention from '@/extend/controls/contratTemplate/ContratTemplateUseConvention';
  import EtablissementSelect from '@/extend/controls/etablissement/EtablissementSelect';
  import ContratTemplate from '@/extend/classes/ContratTemplate';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeContratTemplate } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      ContratTemplateActive,
      ContratTemplateName,
      ContratTemplateTitre,
      ContratTemplateUseConvention,
      EtablissementSelect,
    },

    props: {
      contratTemplate: {
        type: Object as PropType<ContratTemplate>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetEtablissementSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        activeStatus: new FieldStatus(false, false, 0),
        strActive: '',
        nameStatus: new FieldStatus(false, false, 0),
        strName: '',
        titreStatus: new FieldStatus(false, false, 0),
        strTitre: '',
        useConventionStatus: new FieldStatus(false, false, 0),
        strUseConvention: '',
    toggleEtablissementId: false,
        etablissementIdStatus: new FieldStatus(false, false, 0),
        strEtablissementId: '',
        refContratTemplate: new ContratTemplate,
        cloneContratTemplate: new ContratTemplate,
      contratTemplateSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.CONTRAT_TEMPLATE,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editContratTemplate.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editContratTemplate: {
        get(): ContratTemplate {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.contratTemplate != undefined) {
              if (this.contratTemplate.id == 0) {
                Alerts.debug('CrudContratTemplate : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneContratTemplate.id != this.contratTemplate.id && !this.saving) {
                this.handleContratTemplateChange();
              }
            }
          }
          return this.refContratTemplate;
        },
        set(value: ContratTemplate) {
          this.refContratTemplate = value;
        }
      },

      canCreate (): boolean {
        return this.refContratTemplate.id > 0;
      },

      canDelete (): boolean {
        return this.refContratTemplate.canDelete && this.refContratTemplate.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      active: {
        get(): boolean {
          return this.editContratTemplate.active;
        },
        set(value: boolean) {
          this.editContratTemplate.active = value;
          this.fieldUpdated('ACTIVE', value);
        }
      },


      name: {
        get(): string {
          return this.editContratTemplate.name;
        },
        set(value: string) {
          this.editContratTemplate.name = value;
          this.fieldUpdated('NAME', value);
        }
      },


      titre: {
        get(): string {
          return this.editContratTemplate.titre;
        },
        set(value: string) {
          this.editContratTemplate.titre = value;
          this.fieldUpdated('TITRE', value);
        }
      },


      useConvention: {
        get(): boolean {
          return this.editContratTemplate.useConvention;
        },
        set(value: boolean) {
          this.editContratTemplate.useConvention = value;
          this.fieldUpdated('USE_CONVENTION', value);
        }
      },

    resetEtablissementId (): boolean {
      return this.toggleEtablissementId
    },

      etablissementId: {
        get(): number {
          return this.editContratTemplate.etablissementId;
        },
        set(value: number) {
          this.editContratTemplate.etablissementId = value;
          this.fieldUpdated('ETABLISSEMENT_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.contratTemplate.canUpdate && (
        (this.isDisplayed('ACTIVE') && !this.readOnly('ACTIVE')) ||
        (this.isDisplayed('NAME') && !this.readOnly('NAME')) ||
        (this.isDisplayed('TITRE') && !this.readOnly('TITRE')) ||
        (this.isDisplayed('USE_CONVENTION') && !this.readOnly('USE_CONVENTION')) ||
        (this.isDisplayed('ETABLISSEMENT_ID') && !this.readOnly('ETABLISSEMENT_ID')));
        return !res;
      },

      fields (): string[] {
        return ['ACTIVE', 'NAME', 'TITRE', 'USE_CONVENTION', 'ETABLISSEMENT_ID'];
      },
    },

    methods: {
      handleContratTemplateChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.contratTemplate);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.contratTemplate);
          }
        } else if (!this.inDialog) {
          if (this.cloneContratTemplate.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.contratTemplate);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.activeStatus != undefined && this.activeStatus.updated) ||
          (this.nameStatus != undefined && this.nameStatus.updated) ||
          (this.titreStatus != undefined && this.titreStatus.updated) ||
          (this.useConventionStatus != undefined && this.useConventionStatus.updated) ||
          (this.etablissementIdStatus != undefined && this.etablissementIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contratTemplate);
        }
      },

      setError (): void {
        const error = this.activeStatus.error ||
        this.nameStatus.error ||
        this.titreStatus.error ||
        this.useConventionStatus.error ||
        this.etablissementIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contratTemplate);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refContratTemplate.id < 0) {
          storeContratTemplate.mContratTemplateDeleted(this.refContratTemplate.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refContratTemplate.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveContratTemplate()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.contratTemplateSaving = false;
          this.createRef(this.refContratTemplate);
          this.$emit('updated', this.refContratTemplate);
          if (this.contratTemplate.id > 0) {
            this.$emit('saved', this.refContratTemplate);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refContratTemplate.failed) {
          this.saveLoading = false;
            this.contratTemplateSaving = false;
            this.refContratTemplate.failed = false;
          }
        }
      },

      saveContratTemplate (): boolean {
        if (!this.refContratTemplate.compareContratTemplate(this.cloneContratTemplate)) {
          if (!this.contratTemplateSaving) {
            this.contratTemplateSaving = true;
          if (this.refContratTemplate.id > 0) {
            storeContratTemplate.updateContratTemplate(this.refContratTemplate)
              .then((data: ContratTemplate) => {
                if (!data.failed) {
                  this.refContratTemplate = storeContratTemplate.getContratTemplate(data.id);
                  this.cloneContratTemplate = data.cloneContratTemplate();
                } else {
                  this.refContratTemplate.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.contratTemplateSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refContratTemplate.id <= 0) {
              storeContratTemplate.createContratTemplate(this.refContratTemplate)
                .then((data: ContratTemplate) => {
                  if (!data.failed) {
                    this.refContratTemplate = storeContratTemplate.getContratTemplate(data.id);
                    this.cloneContratTemplate = data.cloneContratTemplate();
                  } else {
                this.refContratTemplate.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.contratTemplateSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refContratTemplate.id <= 0) {
          storeContratTemplate.mContratTemplateDeleted(this.refContratTemplate.id);
        } else {
          storeContratTemplate.deleteContratTemplate(this.refContratTemplate);
        }
      },

      statusActive (value: FieldStatus): void {
        this.activeStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusName (value: FieldStatus): void {
        this.nameStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusTitre (value: FieldStatus): void {
        this.titreStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusUseConvention (value: FieldStatus): void {
        this.useConventionStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusEtablissementId (value: FieldStatus): void {
        this.etablissementIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteContratTemplate(): void {
        this.$emit('deleteContratTemplate',  this.contratTemplate);
      },

    addContratTemplate(): void {
      this.$emit('addContratTemplate',  this.contratTemplate);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneContratTemplate != undefined) {
          this.restoring = true;
          this.refContratTemplate.active = this.cloneContratTemplate.active;
          this.refContratTemplate.name = this.cloneContratTemplate.name;
          this.refContratTemplate.titre = this.cloneContratTemplate.titre;
          this.refContratTemplate.useConvention = this.cloneContratTemplate.useConvention;
          this.refContratTemplate.etablissementId = this.cloneContratTemplate.etablissementId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: ContratTemplate): void {
        this.clearRef();
        this.editContratTemplate = value;
        this.cloneContratTemplate = value.cloneContratTemplate();
        this.activeStatus.clear(value.id);
        this.nameStatus.clear(value.id);
        this.titreStatus.clear(value.id);
        this.useConventionStatus.clear(value.id);
        this.etablissementIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ACTIVE') && this.$refs.ACTIVE) this.$refs.ACTIVE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NAME') && this.$refs.NAME) this.$refs.NAME.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TITRE') && this.$refs.TITRE) this.$refs.TITRE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('USE_CONVENTION') && this.$refs.USE_CONVENTION) this.$refs.USE_CONVENTION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ACTIVE') && this.isDisplayed('ACTIVE') && this.$refs.ACTIVE && this.$refs.ACTIVE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NAME') && this.isDisplayed('NAME') && this.$refs.NAME && this.$refs.NAME.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'TITRE') && this.isDisplayed('TITRE') && this.$refs.TITRE && this.$refs.TITRE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'USE_CONVENTION') && this.isDisplayed('USE_CONVENTION') && this.$refs.USE_CONVENTION && this.$refs.USE_CONVENTION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ETABLISSEMENT_ID') && this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID && this.$refs.ETABLISSEMENT_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ACTIVE') && this.$refs.ACTIVE) this.$refs.ACTIVE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NAME') && this.$refs.NAME) this.$refs.NAME.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TITRE') && this.$refs.TITRE) this.$refs.TITRE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('USE_CONVENTION') && this.$refs.USE_CONVENTION) this.$refs.USE_CONVENTION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ETABLISSEMENT_ID') && this.$refs.ETABLISSEMENT_ID) this.$refs.ETABLISSEMENT_ID.save();
      },

      getValue (field: string): string {
         if (field == 'ACTIVE') return this.active.toString();
        else  if (field == 'NAME') return this.name.toString();
        else  if (field == 'TITRE') return this.titre.toString();
        else  if (field == 'USE_CONVENTION') return this.useConvention.toString();
        else  if (field == 'ETABLISSEMENT_ID') return this.etablissementId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
